import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/repairLog/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/repairLog/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/repairLog/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/repairLog/submit', params, options);

export const update = (params, options) => request.post('/api/repairLog/submit', params, options);
